<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <MBtn
    type="submit"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </MBtn>
</template>

<script>
export default {
  name: 'Submit',
  components: { MBtn: () => import('./Btn') }
}
</script>
